export class GameError extends Error {
  constructor(code, message, details = null) {
    super(message);
    this.name = 'GameError';
    this.code = code;
    this.details = details;
  }
}

export function invariant(condition, code, message, details = null) {
  if (!condition) {
    throw new GameError(code, message, details);
  }
}
